module.exports = __webpack_public_path__ + "assets/Getty_mini_map_V3.0200762d.svg";